<!--
External integration component.

Entry point: src/main.ts
Consumed by: Casa
Route: /fantasy-selection/settled-bets
Required verification: test both the standalone Kratos behavior and Casa iframe integration.
-->
<template>
    <div v-resize="onResize" class="settledBets">
        <BetsTable
            v-bind:bets="settledBets"
            v-bind:isLoaded="isLoaded"
        />
    </div>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import BetsTable from '@/components/fantasySelection/myBets/BetsTable.vue';
    import type { SizeInfo } from '@/directives/resize';
    import { useFantasySelectionSettledBetsStore } from '@/store/fantasySelectionSettledBetsStore';

    const { isLoaded, settledBets } = storeToRefs(useFantasySelectionSettledBetsStore());

    let previousHeight = 0;
    const onResize = ({ height }: SizeInfo) => {
        if (previousHeight === height) return;

        previousHeight = height;
        window.parent.postMessage({
            location: window.location.href,
            height: Math.ceil(height),
        }, '*');

        /** sample usage
        window.addEventListener('message', ({ data }) => {
            const iframe = window.document.querySelector(`iframe[src='${data.location}']`) as HTMLIFrameElement;
            iframe.style.height = `${data.height}px`;
        });
        */
    };
</script>
